import { CoreApiClient } from './coreApiClient';
const api = new CoreApiClient('', (...args) => fetch(...args));
export interface FolderDateEvidence {
  projectId:number; description:string|null; published:string; stale:boolean; intakeAvailable:boolean;
  received:string|null; receivedDay:string|null; started:string|null; preliminaryIssued:string|null;
}
export async function fetchFolderDateEvidence(projectId:number):Promise<FolderDateEvidence> {
  const {data} = await api.request<{data:FolderDateEvidence}>('/api/v1/projects/' + projectId + '/folders/date-evidence');
  if (!data || data.projectId !== projectId || typeof data.published !== 'string' || !data.published
    || typeof data.stale !== 'boolean' || typeof data.intakeAvailable !== 'boolean'
    || !(data.description === null || typeof data.description === 'string' && data.description.length <= 1024)
    || !(data.receivedDay === null || /^\d{4}-\d{2}-\d{2}$/.test(data.receivedDay))
    || ![data.received,data.started,data.preliminaryIssued].every(field => field === null || typeof field === 'string')) throw new Error('Unverified folder evidence');
  return data;
}

export interface FolderItems {
  projectId:number; relativePath:string; checked:string; partial:boolean;
  items:Array<{name:string;kind:'file'|'folder';modified:string|null}>;
}

export type StatusDateCandidate = { kind: 'receipt'|'completeness'|'delivery'; day: string; quote: string };
export const statusTextPath = '1-Project Documents/7-AIPM/PROJECT STATUS.txt';
export interface StatusTextEvidence {
  projectId: number; source: string; modified: string|null; checked: string;
  candidates: StatusDateCandidate[]; format: 'le_admin'|'project_note';
}
export async function fetchStatusTextEvidence(projectId: number): Promise<StatusTextEvidence> {
  const {data} = await api.request<{data:StatusTextEvidence}>('/api/v1/projects/' + projectId + '/folders/status-text-evidence');
  if (!data || data.projectId !== projectId || data.source !== statusTextPath || typeof data.checked !== 'string' ||
    !(data.modified === null || typeof data.modified === 'string') || !['le_admin','project_note'].includes(data.format) ||
    !Array.isArray(data.candidates) || !data.candidates.every(candidate => candidate && ['receipt','completeness','delivery'].includes(candidate.kind) &&
      /^\d{4}-\d{2}-\d{2}$/.test(candidate.day) && typeof candidate.quote === 'string' && candidate.quote.trim())) {
    throw new Error('Unverified project status text');
  }
  return data;
}
export async function fetchFolderItems(projectId:number, relativePath:string) {
  const {data} = await api.request<{data:FolderItems}>('/api/v1/projects/' + projectId + '/folders/evidence-items',{query:{relativePath}});
  if (!data || data.projectId !== projectId || data.relativePath !== relativePath || typeof data.checked !== 'string' ||
    typeof data.partial !== 'boolean' || !Array.isArray(data.items) || data.items.length > 25 || !data.items.every(item =>
      item && typeof item.name === 'string' && item.name.length <= 255 && ['file','folder'].includes(item.kind) &&
      (item.modified === null || typeof item.modified === 'string'))) throw new Error('Unverified listing');
  return data;
}
